module.exports = __webpack_public_path__ + "img/w-explore-game.5736c42a.svg";